exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cute-dog-profile-photo{background-color:transparent;border-radius:100%;box-shadow:0 2px 20px 0 rgba(0,0,0,.4);border:1px solid hsla(0,0%,100%,.65)}.cute-dog-profile-photo img{width:260px;height:260px}.ct-top-right{cursor:pointer;padding-top:20px;padding-right:30px;font-weight:600;color:#fff;text-shadow:0 0 20px #000}.scale-enter-active,.scale-leave-active{transition:all .5s}.scale-enter,.scale-leave-active{opacity:0;transform:scale(.3) translateY(24px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-41ab1920","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modals/DogProfileModal.vue
// module id = 16
// module chunks = 0